import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { api } from '@/lib/api';
import { REFUND_REASONS } from '@/pages/AdminShippingRefunds';

const fmt = (n) => `$${Number(n || 0).toLocaleString('es-CO')}`;
const STATUS = { requested: 'En revisión', approved: 'Aprobado, en proceso de devolución', processed: 'Devuelto' };
const day = (iso) => (iso ? new Date(iso).toLocaleDateString('es-CO', { timeZone: 'America/Bogota' }) : '—');

export default function BuyerShippingRefunds() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/me/shipping-refunds').then(({ data }) => setItems(data.items || [])).catch(() => setItems([])); }, []);
  return (
    <Layout>
      <div className="mx-auto max-w-4xl px-4 py-10 pb-24 sm:px-6 lg:px-8" data-testid="buyer-shipping-refunds-page">
        <Link to="/mis-pedidos" className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Mis pedidos</Link>
        <h1 className="mt-1 font-display text-3xl font-black tracking-tighter text-slate-900">Reembolsos de envío</h1>
        <p className="mt-2 text-sm text-slate-600">Aquí ves los reembolsos del valor de envío de tus pedidos. Las condiciones están en la{' '}
          <Link to="/politica-de-envios" className="font-semibold text-orange-600 hover:underline">Política de Tarifas, Envíos y Subsidios</Link>.</p>
        <div className="mt-6 space-y-3">
          {items === null && <p className="text-sm text-slate-400">Cargando…</p>}
          {items?.length === 0 && <p className="border border-slate-200 bg-white p-5 text-sm text-slate-500" data-testid="buyer-srf-empty">No tienes reembolsos de envío.</p>}
          {items?.map((r) => (
            <div key={r.shipping_refund_id} className="flex flex-wrap items-center justify-between gap-2 border border-slate-200 bg-white p-4" data-testid={`buyer-srf-${r.shipping_refund_id}`}>
              <div>
                <div className="font-mono text-xs text-slate-500">Pedido {r.order_id}</div>
                <div className="font-semibold text-slate-900">{REFUND_REASONS[r.reason] || 'Reembolso de envío'}</div>
                <div className="text-xs text-slate-500">Solicitado {day(r.created_at)}{r.processed_at ? ` · Devuelto ${day(r.processed_at)}` : ''}</div>
              </div>
              <div className="text-right">
                <div className="font-display text-xl font-black" data-testid={`buyer-srf-amount-${r.shipping_refund_id}`}>{fmt(r.amount_to_buyer)}</div>
                <div className="text-xs font-semibold text-slate-600" data-testid={`buyer-srf-status-${r.shipping_refund_id}`}>{STATUS[r.status] || r.status}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
